export const riliItemCacheKey = 'tj_riliItemCacheKey';
export const orderItemCacheKey = 'tj_orderItemCacheKey';

export const orderStatus = {
  /**已逾期*/
  OVERDUE: "已逾期",
  /**未支付取消*/
  NO_PAY_CANCEL: "未支付取消",
  /** 取消 */
  CANCEL: "已取消",
  /** 待付款 */
  WAIT_PAY: "待付款",
  /** 待安排 */
  WAIT_HANDLE: "待安排",
  /** 待体检 */
  WAIT_CHECK: "待体检",
  /** 已到检 */
  ALREADY_CHECK: "已到检",
  /** 已完成 */
  FINSH: "已完成"
};

//-4-已逾期，-3-未支付取消，-1-已取消，0-待付款，2-待安排，4-待体检，5-已到检，6-已完成
export const orderStatusList = [
  {id: "-4", name: '已逾期'},
  {id: "2", name: '未预约'},
  {id: "4", name: '已预约'},
  {id: "5", name: '已到检'},
]
